import React from 'react';
import OnMountAndUpdate from '@atlassian/jira-common-util-op-triggers/src/on-mount-and-update/OpTrigger.tsx';
import TagMauEvent from '../../tag-mau/index.tsx';
import { getSubProductFromProjectType } from '../transformations.tsx';
import setCurrentSubProduct from './set-current-sub-product-and-solutions.tsx';
import { isSubProductProps, type Props } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { Props };

export const SubProductUpdater = ({ allowMonolithDeferral = false, ...props }: Props) => {
	const subProduct = isSubProductProps(props)
		? props.subProduct
		: getSubProductFromProjectType(props.projectType);

	return (
		<>
			<OnMountAndUpdate op={setCurrentSubProduct} args={[subProduct, allowMonolithDeferral]} />
			<TagMauEvent subProduct={subProduct} />
		</>
	);
};
